import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles((theme) => ({
    container: {
        width: "100%",
        height: "50px"
      },
      button: {
        padding: '0.3rem 1rem',
        fontSize: '12px',
        marginRight: '10px',
        whiteSpace: 'nowrap',
    },
      box: {
        maxHeight: '30px',
        minHeight: '30px',
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'flex-end',
        justifyContent: 'left',
    },
      textfield: {
        minWidth: 50,
        maxWidth: 200,
        width: '100%',
        height: 30,
        marginLeft:'10px'
    },
    buttonWrap: {
      maxHeight: '30px',
      minHeight: '30px',
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'flex-end',
      justifyContent: 'left',
      marginLeft:'10px'
  },
  textLabel:{
    marginLeft:'10px'
  },
  dropdown: {
    minWidth: 50,
    maxWidth: 300,
    width: '100%',
    textOverflow: 'ellipsis',
    height: 30,
    marginLeft:'10px',
  },
  unSelected: {
    color: theme.palette.grey[500],
  },
 menuItems: {   
    padding:'0px',
    maxHeight:'30px',

},
multiselect: {
  minWidth: 50,
  maxWidth: 300,
  width: '100%',
  height: 30,
  textOverflow: 'ellipsis',
},
multiText:{
  borderStyle:'none',
  minWidth: 50,
  width: '100%',
  height: 30,
}
}));

export default useStyles;